import { DocumentNode, gql } from '@apollo/client'

export const GET_STAFF_PREPARATION_TASKS_BY_DAYCARE: DocumentNode = gql`
    query GetStaffPreparationTasks($daycareId: Int!) {
        getStaffPreparationTasksByDaycare(daycareId: $daycareId) {
            id
            daycareId
            name
            duration
        }
    }
`

export const CREATE_STAFF_PREPARATION_TASK: DocumentNode = gql`
    mutation CreateStaffPreparationTask($daycareId: Int!, $staffPreparationTask: StaffPreparationTaskInput!) {
        createStaffPreparationTask(daycareId: $daycareId, staffPreparationTask: $staffPreparationTask)
    }
`

export const UPDATE_STAFF_PREPARATION_TASK: DocumentNode = gql`
    mutation UpdateStaffPreparationTask(
        $staffPreparationTaskId: Int!
        $staffPreparationTask: StaffPreparationTaskInput!
        $daycareId: Int!
    ) {
        updateStaffPreparationTask(
            staffPreparationTaskId: $staffPreparationTaskId
            staffPreparationTask: $staffPreparationTask
            daycareId: $daycareId
        )
    }
`

export const DELETE_STAFF_PREPARATION_TASK: DocumentNode = gql`
    mutation DeleteStaffPreparationTask($staffPreparationTaskId: Int!, $daycareId: Int!) {
        deleteStaffPreparationTask(staffPreparationTaskId: $staffPreparationTaskId, daycareId: $daycareId)
    }
`

export const GET_FUTURE_WORK_COUNT_FOR_STAFF_PREPARATION_TASK: DocumentNode = gql`
    query GetFutureWorkCountForStaffPreparationTask($staffPreparationTaskId: Int!, $daycareId: Int!) {
        getFutureWorkCountForStaffPreparationTask(
            staffPreparationTaskId: $staffPreparationTaskId
            daycareId: $daycareId
        )
    }
`
